import axios, { AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { localStorageKeys } from "../../config/localStorageKeys";
import { PartnerType } from "@/app/utils/partners.enum";
import {
  JOURNEY_FIELD,
  JOURNEY_HEADER,
  JOURNEY_PRODUCT_HEADER,
  journeyStore,
} from "../journey";

declare module "axios" {
  export interface AxiosRequestConfig {
    journey?: PartnerType;
  }
}

/** leva o id da jornada em andamento, ou declara o produto quando ainda não há */
function attachJourney(config: InternalAxiosRequestConfig) {
  const product = config.journey;

  if (!product) return config;

  const journeyId = journeyStore.get(product);

  if (journeyId) config.headers[JOURNEY_HEADER] = journeyId;
  else config.headers[JOURNEY_PRODUCT_HEADER] = product;

  return config;
}

/** a API devolve o id no corpo, não em header: não depende de CORS */
function captureJourney(response: AxiosResponse) {
  const product = response.config?.journey;
  const journeyId = (response.data as Record<string, unknown> | undefined)?.[
    JOURNEY_FIELD
  ];

  if (product && typeof journeyId === "string") {
    journeyStore.set(product, journeyId);
  }

  return response;
}

export const basicClient = axios.create();

const defaultHeaders = {
  Accept: "application/json",
  "X-Origin": "WEB",
  "X-Platform": "web",
};

export const httpClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: defaultHeaders,
});

export const apiFGTS = axios.create({
  baseURL: import.meta.env.VITE_API_FGTS_URL,
  headers: defaultHeaders,
});

export const adminApi = axios.create({
  baseURL: import.meta.env.VITE_API_ADMIN_URL,
  headers: defaultHeaders,
});

export const reportApi = axios.create({
  baseURL: import.meta.env.VITE_API_REPORTS_URL || import.meta.env.VITE_API_URL,
});

httpClient.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem(localStorageKeys.ACCESS_TOKEN);

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});

httpClient.interceptors.request.use(attachJourney);
httpClient.interceptors.response.use(captureJourney);

apiFGTS.interceptors.request.use(attachJourney);
apiFGTS.interceptors.response.use(captureJourney);

apiFGTS.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem(localStorageKeys.ACCESS_TOKEN);

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});

reportApi.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem(localStorageKeys.ACCESS_TOKEN);

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});
